// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__bevbF","title":"ClientInsurance_title__3GDI0","itemText":"ClientInsurance_itemText__72MBN"};